import { Injectable } from '@angular/core';
import { API_URL } from 'common/constants/url.constants';
import { WelcomeListingModel, WelcomeModel } from 'common/models/pagemodels/welcome/welcome.model';
import { ResponseAndErrorModel } from 'common/models/utilitymodels/base.model';
import { ListModel, QueryParams, paginationType } from 'common/models/utilitymodels/list.model';
import { HttpService } from 'common/services/core_services/http.service';
import { ListDataService } from 'common/services/core_services/list.data.service';
import { SystemService } from 'common/services/core_services/system.service';

@Injectable({
    providedIn: 'root',
})
export class WelcomeService extends ListDataService<WelcomeModel, WelcomeListingModel> {
    constructor(protected httpService: HttpService, protected systemService: SystemService) {
        super(API_URL.prostartWelcomeList, httpService);
    }

    getAPI_URL(): any {
        return { videoListURL: API_URL.prostartWelcomeList, testimonialURL: API_URL.testimonial, countURL: API_URL.count };
    }

    createQueryParams(param: QueryParams): QueryParams {
        return param;
    }

    public dataModel(): WelcomeModel {
        return new WelcomeModel();
    }

    listgetDatafromAPI(params: any): Promise<any> {
        const paramUrl: any = this.modifyAPI_URL(params);

        return new Promise((resolve, reject) => {
            if (this.systemService.deviceInfo.platform === 'web') {
                const allPromises = Promise.all([this.httpService.getData(paramUrl['videoListURL']), this.httpService.getData(paramUrl['testimonialURL']), this.httpService.getData(paramUrl['countURL'])]);
                allPromises
                    .then((data) => {
                        resolve(this.transformSuccessData(data, params));
                    })
                    .catch((error: any) => {
                        if (this.resResolveOrReject()) {
                            resolve(this.transformErrorData(error, params));
                        } else {
                            reject(error);
                        }
                    });
            } else {
                resolve(this.transformSuccessData([], params));
            }
        });
    }

    transformSuccessData(data: any, params: any) {
        let apiRes: any[] = [];
        data.forEach((res: any) => {
            if (res.Error) {
                apiRes = [];
            } else {
                apiRes = [...apiRes, res.datalist];
            }
        });
        const res = new ResponseAndErrorModel(apiRes, []);
        return res;
    }

    createListModel(apiRes: any, param: QueryParams): Promise<any> {
        return new Promise((resolve, reject) => {
            try {
                const listModel = new WelcomeListingModel();

                listModel.list = apiRes.data[0];
                listModel.errorModel = [...apiRes.error];
                listModel.listMaster = listModel.list;
                listModel.pageModel = [];
                listModel.pages = [];
                listModel.searchText = '';
                listModel.selectedPage = param.currentPage;
                listModel.searchText = param.searchText;
                listModel.recordPerPage = param.recordPerPage;
                listModel.totalRecords = listModel.list?.length;
                listModel.filterList = listModel.list?.slice(0, 3);
                listModel.testimonialList = apiRes?.data[1];
                listModel.testimonialFilterList = listModel?.testimonialList;
                listModel.countList = apiRes?.data[2];
                listModel.countFilterList = listModel?.countList;
                resolve(listModel);
            } catch (e) {
                reject(e);
            }
        });
    }
}
